import { Link } from "gatsby";
import _ from "lodash";
import React from "react";
import { SelectedTagContext } from "./SelectedTagContext";

type BlogPostTagProps = {
    tag: string;
    size?: "small" | "medium"
    clickable?: boolean
}

export function BlogPostTag({ tag, clickable, size }: BlogPostTagProps) {
    const selectedTag = React.useContext(SelectedTagContext);

    const tagColor = selectedTag === tag ? "bg-pink-400" : "bg-blue-500";
    const fontSize = (size ?? "small") === "small" ? "text-xs" : "text-base";
    const hover = (clickable ?? true) ? "hover:underline" : "";

    const classes = `py-0.5 px-2 text-white select-none ${fontSize} ${tagColor} ${hover}`;

    return (
        <span className={classes}>
            {
                (clickable ?? true) 
                ? <Link to={`/tags/${_.kebabCase(tag)}/`}>{tag}</Link>
                : tag
            }
        </span>
    );
}
